import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class BreakpointService {

    private readonly breakpoints = [
        {
            min: 0,
            max: 370,
            name: 'tiny'
        },
        {
            min: 371,
            max: 700,
            name: 'default'
        },
        {
            min: 701,
            max: 960,
            name: 'medium'
        },
        {
            min: 961,
            max: 1100,
            name: 'large'
        },
        {
            min: 1101,
            max: Infinity,
            name: 'x-large'
        }
    ];
    private currentBreakpoint$: BehaviorSubject<string>;

    constructor() {
    }

    public getBreakpoint(): Observable<string> {
        return this.currentBreakpoint$.asObservable().pipe(
            distinctUntilChanged()
        );
    }

    public onResize(width: number): void {

        const breakpoint = this.convertWidthToBreakpoint(width);

        if (typeof this.currentBreakpoint$ !== 'undefined') {
            this.currentBreakpoint$.next(breakpoint);
        }
        else {
            this.currentBreakpoint$ = new BehaviorSubject<string>(breakpoint)
        }
    }

    public convertWidthToBreakpoint(width: number): string {

        // Loop through breakpoints
        for (const breakpoint of this.breakpoints) {

            // If in breakpoint range => return breakpoint name
            if (width <= breakpoint.max) {
                return breakpoint.name;
            }
        }
    }
}